import Helpers from "commons/helpers";
import Constants from "constants/index";
import MedkitService from "./medkit.service";
import {
    IRecordReport,
    IRequestReportAnalyze,
    IRequestReportAssign,
    IRequestReportCreateUpdate,
    IResponseGetPaged,
} from "commons/interfaces";
import { ContentType } from "services/apiProcessor";
import { BooleanInt } from "constants/enum";


class ReportService extends MedkitService {
    public getPaged = async (data: {
        organizationId?: string;
        reportStatus?: string;
        endTime?: string | number;
        startTime?: string | number;
        reportType?: string;
        byHospitals?: string;
        isMonitoring?: number;
        incidentObject?: string;
        onlyOpenedReport?: number;
        firstAffectValuation?: string;
        tagIds?: string[];
        memberIds?: string[];
        repeatIssues?: number[];
        incidentPlaces?: string[];
        anonymousReporter?: BooleanInt;
        searchText?: string;
        orderby?: number;
        pageSize?: number;
        pageNumber?: number;
    }): Promise<IResponseGetPaged<IRecordReport>> => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({ path: Constants.ApiPath.REPORT.GET_PAGED + `?${query}` });
        return result.data.result;
    }

    public detail = async (id: string): Promise<IRecordReport> => {
        const result = await this.api.get({ path: Constants.ApiPath.REPORT.DETAIL + `/${id}` });
        return result.data.result;
    }

    public create = async (data: IRequestReportCreateUpdate) => {
        const result = await this.api.post({ path: Constants.ApiPath.REPORT.CREATE, data });
        return result.data.result;
    }

    public update = async (data: IRequestReportCreateUpdate) => {
        const result = await this.api.put({ path: Constants.ApiPath.REPORT.UPDATE, data });
        return result.data.result;
    }

    public updateStatus = async (data: { id: string, reportStatus: string }) => {
        const result = await this.api.put({ path: Constants.ApiPath.REPORT.UPDATE_STATUS, data });
        return result.data.result;
    }

    public updateRepeatIssue = async (data: { id: string, referenceId?: string }) => {
        const result = await this.api.put({ path: Constants.ApiPath.REPORT.UPDATE_REPEAT_ISSUE, data });
        return result.data.result;
    }

    public analyzeReport = async (data: IRequestReportAnalyze) => {
        const result = await this.api.put({ path: Constants.ApiPath.REPORT.ANALYZE_REPORT, data });
        return result.data.result;
    }

    public assignReport = async (data: IRequestReportAssign) => {
        const result = await this.api.put({ path: Constants.ApiPath.REPORT.ASSIGN_REPORT, data });
        return result.data.result;
    }

    public delete = async (id: string) => {
        const result = await this.api.delete({ path: Constants.ApiPath.REPORT.DELETE + `/${id}` });
        return result.data.result;
    }

    public generatingAssignReports = async (data: {
        serviceCode?: string,
        organizationId?: string,
        startTime?: any,
        endTime?: any,
        reportType?: string,
        searchText?: string,
        byHospital?: string,
        isMonitoring?: string,
        incidentObject?: string,
        firstAffectValuation?: string,
        reportStatus?: string[],
        repeatIssues?: string[],
        incidentPlaces?: string[],
    }) => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            contentType: ContentType.EXCEL,
            path: Constants.ApiPath.REPORT.GENERATING_ASSIGN_REPORTS + `${query ? "?" : ""}${query}`,
        });
        return result.data;
    }

    public generatingPL = async (data: { id: string, reportType: string }) => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            contentType: ContentType.PDF,
            path: Constants.ApiPath.REPORT.GENERATING_PL + `${query ? "?" : ""}${query}`,
        });
        return result.data;
    }

    public generatingSynthesisReport = async (data: {
        endTime: any,
        startTime: any,
        levelReport: string,
        incidentPlaces?: string[],
    }) => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            contentType: ContentType.ZIP,
            path: Constants.ApiPath.REPORT.GENERATING_SYNTHESIS_REPORT + `${query ? "?" : ""}${query}`,
        });
        return result.data;
    }

    public generatingUnexpectedIncidentReport = async (data: { startTime: any, endTime: any, template?: number }) => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            timeout: 5 * 60 * 1000, // 5 minute
            contentType: ContentType.DOCX,
            path: Constants.ApiPath.REPORT.GENERATING_UNEXPECTED_INCIDENT_REPORT + `${query ? "?" : ""}${query}`,
        });
        return result.data;
    }

    public updateFishboneAnalysis = async (data: { fishboneAnalysis: string, fishbonePhotoId: string, id: string }) => {
        const result = await this.api.put({
            path: Constants.ApiPath.REPORT.UPDATE_FISHBONE_ANALYSIS,
            data
        });
        return result.data;
    }

    

};

export default ReportService;